import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Loadfirst from './Loadfirst';
import { AuthProvider } from "./AuthContext";
import { Login } from '@mui/icons-material';
import Loadfirsts from './Loadfirst';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Modern.css';
import './Compact.css';


ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Loadfirst />      
    </AuthProvider>
      {/* <App /> */}
  </React.StrictMode>,
  document.getElementById('root')
);
